/* The legacy Meta pixel has one PageView owner. Its SDK is loaded only with Shopify marketing consent.
   A slow SDK must not replay a PageView or booking after consent has been withdrawn. */
(() => {
  if (window.LaserlabMeta) return;
  const state = window.LaserlabMeta = { ready: false };
  const pixelId = '1153054833447896';
  const sdkUrl = 'https://connect.facebook.net/en_US/fbevents.js';
  let initialized = false;
  let pageViewSent = false;
  let consent = null;
  let loader = null;
  let retryTimer;
  let retries = 0;

  function allowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true;
    } catch (error) { return false; }
  }

  function syncConsent(granted) {
    if (typeof window.fbq !== 'function' || consent === granted) return;
    window.fbq('consent', granted ? 'grant' : 'revoke');
    consent = granted;
  }

  function loadSdk() {
    if (!allowed() || loader) return;
    if (typeof window.fbq !== 'function') {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
    }
    // The SDK starts paused; process() grants only after it is ready and consent is checked again.
    syncConsent(false);
    loader = Array.from(document.querySelectorAll('script[src]')).find(script => /connect\.facebook\.net\/.*fbevents\.js/.test(script.src));
    if (!loader) {
      loader = document.createElement('script');
      loader.async = true;
      loader.src = sdkUrl;
      loader.addEventListener('load', process, { once: true });
      document.head.appendChild(loader);
    } else {
      loader.addEventListener('load', process, { once: true });
    }
  }

  function process() {
    if (retryTimer) window.clearTimeout(retryTimer);
    if (!allowed()) {
      state.ready = false;
      try { syncConsent(false); } catch (error) { /* No tracking while consent is absent. */ }
      return;
    }
    try {
      if (typeof window.fbq !== 'function' || typeof window.fbq.callMethod !== 'function') {
        state.ready = false;
        loadSdk();
      } else {
        syncConsent(true);
        if (!initialized) {
          // Filter pushState/replaceState changes are not new pages.
          window.fbq.disablePushState = true;
          window.fbq('init', pixelId);
          initialized = true;
        }
        if (!pageViewSent) {
          pageViewSent = true;
          try { window.fbq('trackSingle', pixelId, 'PageView'); }
          catch (error) { pageViewSent = false; throw error; }
        }
        const wasReady = state.ready;
        state.ready = true;
        if (!wasReady) document.dispatchEvent(new CustomEvent('ll:meta-ready'));
        return;
      }
    } catch (error) { state.ready = false; /* Measurement never blocks the page. */ }
    if (retries < 10) {
      retries += 1;
      retryTimer = window.setTimeout(process, 1000);
    }
  }

  document.addEventListener('visitorConsentCollected', process);
  window.addEventListener('pageshow', process);
  process();
  const shopify = window.Shopify;
  if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) process(); });
    } catch (error) { /* Missing privacy API: no SDK or PageView. */ }
  }
})();
